// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ShoppingBasketAddIconSignature {
  Element: SVGSVGElement;
}

export const ShoppingBasketAddIcon: TOC<ShoppingBasketAddIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.802 8.99999L17.691 14H15.643L16.754 8.99999H3.246L4.803 16H13V18H4C3.531 18 3.125 17.675 3.023 17.217L1.197 8.99999H0V6.99999H3.42L7.132 0.503991L8.869 1.49599L5.723 6.99999H14.277L11.132 1.49499L12.868 0.502991L16.58 6.99999H20V8.99999H18.802ZM21 19H24V21H21V24H19V21H16V19H19V16H21V19Z"/>
</svg>
</template>;